import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    padding: indent,
    width: 400,
    height: '100%',
    alignSelf: 'center',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: indent,
  },
  headerTitle: {
    fontSize: 18,
    color: '#333',
  },
  closeButton: {
    padding: 4,
  },
  content: {
    alignItems: 'center',
  },
  messagePreview: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginBottom: indent * 1.5,
    fontStyle: 'italic',
  },
  optionsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginBottom: indent,
  },
  optionItem: {
    alignItems: 'center',
    minWidth: 80,
    paddingHorizontal: 8,
  },
  iconWrapper: {
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  optionLabel: {
    fontSize: 14,
    color: '#333',
  },
});
